import { Link } from "react-router-dom";

/**
 * DapNow brand logo — official HD lockup provided by the user.
 * Always renders the full lockup: pin mark + "DapNow" + payoff "DELIVERY AT PLACE, NOW".
 *
 * Asset: /brand/dapnow-logo.png (2172×724), identical to the supplied original.
 *
 * Props:
 *   variant: "dark" (default) | "light" — light adds a frame on dark backgrounds
 *   size:    "sm" | "md" (default) | "lg" | "xl"
 *   to:      router link target (default "/")
 */
export function Logo({
  className = "",
  variant = "dark",
  size = "md",
  showPayoff,  // accepted for backward-compat but ignored (logo always shows the lockup)
  to = "/",
  testId = "brand-logo",
}) {
  void showPayoff;
  // Width-based sizing preserves the full original lockup and lets narrow
  // headers shrink the logo only as much as their adjacent controls require.
  const widths = {
    sm: "w-48 sm:w-56",
    md: "w-52 sm:w-60",
    lg: "w-60 sm:w-72",
    xl: "w-72 sm:w-96",
  };
  const width = widths[size] || widths.md;
  const frame = variant === "light" ? "shadow-md ring-1 ring-white/25" : "";

  return (
    <Link
      to={to}
      data-testid={testId}
      className={`inline-flex min-w-0 max-w-full items-center self-center overflow-hidden rounded-xl bg-white ${width} ${frame} focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-dapnow-blue ${className}`}
      aria-label="DapNow — Delivery At Place, Now"
    >
      <img
        src="/brand/dapnow-logo.png"
        alt="DapNow — Delivery At Place, Now"
        width={2172}
        height={724}
        className="block h-auto w-full object-contain"
        decoding="async"
        loading="eager"
      />
    </Link>
  );
}

/**
 * DapNowMark — just the pin icon (no text). Used for very tight spaces (mobile nav, badges).
 */
export function DapNowMark({ className = "h-8 w-8", title = "DapNow" }) {
  return (
    <img
      src="/brand/dapnow-mark.png"
      alt={title}
      className={className}
      decoding="async"
      loading="eager"
    />
  );
}

export default Logo;
